import { render } from "./PowerBI.vue?vue&type=template&id=76dcfa92&ts=true"
import script from "./PowerBI.vue?vue&type=script&lang=ts"
export * from "./PowerBI.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__